import { Button } from 'components';

import styled from 'styled-components';
import { FrameHeaderHeight } from 'styles/constants';

const drawActiveTriangleUnderCSS = (color: string) => `
  position: relative;
  // overflow: visible;
  &::after {
    content: '';
    position: absolute;
    right: calc(50% - 13px);
    bottom: -8px;

    border-top: 8px solid ${color};
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
  }
`;

export const ButtonStyled = styled(Button)`
  height: ${FrameHeaderHeight}px;
  border: none;
  color: white;
  padding: ${props => props.theme.spacing.default};
  align-items: center;
  background-color: ${props => props.theme.color.wfBlack};
  // font-weight: ${props => props.theme.font.weight.xbold};
  border-radius: 0;
  font-size: ${props => props.theme.font.size.small};

  &:hover {
    color: ${props => props.theme.color.wfGrey500};
    background-color: ${props => props.theme.color.wfBlack};
    border-color: currentColor;
    text-decoration: none;
  }
`;

// prettier-ignore
export const MakeButtonStyled = styled(ButtonStyled)`
  min-width: auto;
  padding: 0 1rem;
  background-color: ${props => props.theme.color.wfBlue};


  &:hover {
    color: ${props => props.theme.color.wfWhite};
    background-color: ${props => props.theme.color.wfBlue900};
    ${props =>
    props.active && drawActiveTriangleUnderCSS(props.theme.color.wfBlue900)}
  }

  ${props =>
    props.active && drawActiveTriangleUnderCSS(props.theme.color.wfBlue)}
`;

// prettier-ignore
export const ChatButtonStyled = styled(ButtonStyled)`
  min-width: auto;
  padding: 0 1rem;
  background-color: ${props => props.theme.color.wfGrey};


  &:hover {
    color: ${props => props.theme.color.wfWhite};
    background-color: ${props => props.theme.color.wfGrey900};
    ${props =>
    props.active && drawActiveTriangleUnderCSS(props.theme.color.wfGrey900)}
  }

  ${props =>
    props.active && drawActiveTriangleUnderCSS(props.theme.color.wfGrey)}
`;

export const FeaturesWrapper = styled.div({
  display: 'flex',
});
